export const servicesOverview = {
  description:
    "En Ventra Core ofrecemos soluciones integrales en climatización, electricidad especializada, energía de respaldo y servicios generales para todo tipo de industrias. Cada uno de nuestros servicios está respaldado por más de 15 años de experiencia y un equipo técnico altamente capacitado.",
  services: [
    {
      slug: "hvac",
      title: "HVAC",
      shortDesc: "Calefacción, ventilación, aire acondicionado y aires de precisión.",
      image: "https://readdy.ai/api/search-image?query=Commercial%20building%20rooftop%20with%20multiple%20HVAC%20air%20conditioning%20units%20and%20ventilation%20systems%20under%20a%20clear%20sky%20in%20professional%20installation&width=600&height=380&seq=vc-svc-14&orientation=landscape",
    },
    {
      slug: "congelacion",
      title: "Congelación y Refrigeración",
      shortDesc: "Sistemas de congelación, refrigeración y enfriamiento para diversos sectores.",
      image: "https://readdy.ai/api/search-image?query=Industrial%20walk-in%20freezer%20and%20cold%20storage%20room%20with%20stainless%20steel%20refrigeration%20equipment%20in%20a%20professional%20food%20processing%20facility&width=600&height=380&seq=vc-svc-15&orientation=landscape",
    },
    {
      slug: "equipo-especializado",
      title: "Equipo Especializado",
      shortDesc: "Implementación de sistemas HVAC en grandes proyectos con tecnología de vanguardia.",
      image: "https://readdy.ai/api/search-image?query=Large%20scale%20industrial%20HVAC%20chiller%20unit%20and%20precision%20cooling%20equipment%20installed%20in%20a%20professional%20facility%20with%20technical%20infrastructure&width=600&height=380&seq=vc-svc-16&orientation=landscape",
    },
    {
      slug: "electricos-especializados",
      title: "Eléctricos Especializados",
      shortDesc: "Mantenimiento de plantas de emergencia, UPS, subestaciones eléctricas, paneles solares y cursos de capacitación técnica.",
      image: "https://readdy.ai/api/search-image?query=Professional%20electrical%20substation%20with%20transformers%20switchgear%20and%20control%20panels%20in%20a%20clean%20modern%20industrial%20electrical%20facility&width=600&height=380&seq=vc-svc-17&orientation=landscape",
    },
    {
      slug: "energia-ups",
      title: "Energía & UPS",
      shortDesc: "Soluciones de energía de respaldo con UPS para centros de datos, equipos críticos y monitoreo remoto.",
      image: "https://readdy.ai/api/search-image?query=Row%20of%20modern%20UPS%20uninterruptible%20power%20supply%20units%20in%20a%20data%20center%20environment%20with%20organized%20battery%20backup%20systems%20and%20clean%20cabling&width=600&height=380&seq=vc-svc-18&orientation=landscape",
    },
    {
      slug: "instalacion-y-mantenimiento",
      title: "Instalación y Mantenimiento",
      shortDesc: "Servicio completo de instalación, mantenimiento preventivo y correctivo de todo tipo de sistemas.",
      image: "https://readdy.ai/api/search-image?query=Professional%20HVAC%20maintenance%20technician%20servicing%20air%20conditioning%20equipment%20with%20tools%20in%20a%20modern%20clean%20industrial%20facility%20environment&width=600&height=380&seq=vc-svc-19&orientation=landscape",
    },
  ],
};

export const hvacData = {
  intro:
    "Nuestros servicios de HVAC (calefacción, ventilación y aire acondicionado) están diseñados para garantizar el confort térmico, la calidad del aire y la eficiencia energética en cualquier tipo de instalación. Desde oficinas corporativas hasta centros de datos, hospitales y plantas industriales.",
  features: [
    {
      title: "Calefacción",
      description:
        "Diseño e instalación de sistemas de calefacción central, calentadores de agua, boilers industriales y sistemas de calefacción por aire forzado para mantener temperaturas óptimas en invierno.",
      icon: "ri-fire-line",
    },
    {
      title: "Ventilación",
      description:
        "Sistemas de ventilación mecánica, extractores, conductos de aire y ventilación natural asistida para garantizar la renovación del aire y eliminar contaminantes en espacios cerrados.",
      icon: "ri-windy-line",
    },
    {
      title: "Aire Acondicionado",
      description:
        "Instalación, mantenimiento y reparación de sistemas de aire acondicionado central, minisplits, cassette, VRF, y unidades tipo paquete para todo tipo de espacios.",
      icon: "ri-temp-cold-line",
    },
    {
      title: "Aires de Precisión",
      description:
        "Sistemas especializados de climatización para centros de datos, cuartos limpios, hospitales y laboratorios donde el control exacto de temperatura y humedad es crítico.",
      icon: "ri-dashboard-line",
    },
    {
      title: "Monitoreo IoT",
      description:
        "Implementación de sensores inteligentes y plataformas de monitoreo en tiempo real para optimizar el rendimiento de tus sistemas HVAC y reducir consumo energético.",
      icon: "ri-radar-line",
    },
    {
      title: "Eficiencia Energética",
      description:
        "Auditorías energéticas, optimización de equipos existentes y propuesta de soluciones de alta eficiencia para reducir costos operativos y cumplir con normativas ambientales.",
      icon: "ri-flashlight-line",
    },
  ],
  contact:
    "En caso de requerir asesoría personalizada para elegir la solución adecuada a tu requerimiento, favor de contactarnos al teléfono: +52 477 284 70 60 / correo: comercial@ventracore.com.mx",
};

export const electricosData = {
  intro:
    "Nuestra división de sistemas eléctricos especializados ofrece servicios de alta calidad para garantizar la continuidad operativa de tus instalaciones. Desde mantenimiento preventivo de UPS hasta instalación de subestaciones eléctricas y paneles solares.",
  features: [
    {
      title: "Mantenimiento de UPS",
      description:
        "Servicio preventivo y correctivo de sistemas UPS de todas las capacidades. Reemplazo de baterías, pruebas de carga, calibración de sensores y certificación de funcionamiento.",
      icon: "ri-battery-charge-line",
    },
    {
      title: "Plantas de Emergencia",
      description:
        "Instalación, mantenimiento y reparación de plantas de emergencia y generadores eléctricos. Servicio de arranque automático, pruebas periódicas y suministro de combustible.",
      icon: "ri-lightbulb-flash-line",
    },
    {
      title: "Subestaciones Eléctricas",
      description:
        "Diseño, instalación y mantenimiento de subestaciones eléctricas de media y alta tensión. Transformadores, tableros de distribución y sistemas de protección eléctrica.",
      icon: "ri-hammer-line",
    },
    {
      title: "Paneles Solares",
      description:
        "Instalación de sistemas fotovoltaicos para reducir el consumo de energía de la red. Diseño personalizado, montaje, conexión a la CFE y monitoreo de producción.",
      icon: "ri-sun-line",
    },
    {
      title: "Sistemas de Tierras",
      description:
        "Diseño e instalación de sistemas de puesta a tierra física, medición de resistencia de tierra, mejoramiento de sistemas existentes y certificación conforme a la NOM.",
      icon: "ri-earth-line",
    },
    {
      title: "Capacitación Técnica",
      description:
        "Cursos de capacitación técnica para el personal de mantenimiento en sistemas eléctricos, HVAC, manejo de refrigerantes, seguridad industrial y normativas aplicables.",
      icon: "ri-book-open-line",
    },
  ],
  contact:
    "En caso de requerir asesoría personalizada para elegir la solución adecuada a tu requerimiento, favor de contactarnos al teléfono: +52 477 284 70 60 / correo: comercial@ventracore.com.mx",
};

export const energiaUPSData = {
  intro:
    "Ofrecemos soluciones de energía de respaldo (UPS) especializadas para centros de datos, equipos críticos, hospitales y cualquier instalación donde la continuidad eléctrica sea indispensable. Protegemos tu infraestructura contra cortes, fluctuaciones y picos de voltaje.",
  features: [
    {
      title: "UPS Monofásicos y Trifásicos",
      description:
        "Venta e instalación de sistemas UPS de doble conversión desde 1 kVA hasta 600 kVA. Soluciones en torre y montaje en rack para todo tipo de infraestructura.",
      icon: "ri-battery-2-charge-line",
    },
    {
      title: "Baterías de Respaldo",
      description:
        "Suministro e instalación de bancos de baterías de alta durabilidad (VRLA, litio). Diseño de autonomía personalizada según los requerimientos de carga de tu instalación.",
      icon: "ri-battery-line",
    },
    {
      title: "Monitoreo Remoto",
      description:
        "Plataformas de supervisión en tiempo real del estado de tus UPS, consumo eléctrico, temperatura de baterías y alertas automáticas ante cualquier anomalía.",
      icon: "ri-remote-control-line",
    },
    {
      title: "Plantas de Emergencia",
      description:
        "Soluciones integrales de energía de respaldo con generadores diésel y gas. Sincronización con UPS para transición sin interrupciones durante fallas de red prolongadas.",
      icon: "ri-flashlight-line",
    },
    {
      title: "Pólizas de Mantenimiento",
      description:
        "Contratos de mantenimiento preventivo mensual, trimestral o semestral para garantizar la disponibilidad óptima de tus sistemas de respaldo energético durante todo el año.",
      icon: "ri-file-list-3-line",
    },
    {
      title: "Auditoría Eléctrica",
      description:
        "Estudios de calidad de energía, análisis de armónicos, factor de potencia y propuestas de mejora para optimizar el consumo y proteger tus equipos sensibles.",
      icon: "ri-bar-chart-grouped-line",
    },
  ],
  contact:
    "En caso de requerir asesoría personalizada para elegir la solución adecuada a tu requerimiento, favor de contactarnos al teléfono: +52 477 284 70 60 / correo: comercial@ventracore.com.mx",
};

export const instalacionMantenimientoData = {
  intro:
    "Brindamos servicios integrales de instalación, mantenimiento preventivo y correctivo de sistemas HVAC, eléctricos y de energía de respaldo. Nuestro equipo de técnicos certificados garantiza que tus equipos operen al máximo rendimiento durante toda su vida útil.",
  features: [
    {
      title: "Instalación Profesional",
      description:
        "Ejecución de proyectos llave en mano desde el diseño hasta la puesta en marcha. Instalación de equipos HVAC, eléctricos, UPS y sistemas de monitoreo conforme a normativas y estándares internacionales.",
      icon: "ri-tools-line",
    },
    {
      title: "Mantenimiento Preventivo",
      description:
        "Visitas programadas con inspección, limpieza, calibración y ajuste de equipos. Identificación temprana de posibles fallas antes de que afecten la operación.",
      icon: "ri-calendar-check-line",
    },
    {
      title: "Mantenimiento Correctivo",
      description:
        "Respuesta rápida ante fallas inesperadas. Diagnóstico, reparación y reemplazo de componentes dañados con refacciones originales y garantía de servicio.",
      icon: "ri-first-aid-kit-line",
    },
    {
      title: "Pólizas de Servicio",
      description:
        "Contratos de mantenimiento personalizados con cobertura mensual, trimestral o anual. Incluyen inspecciones, refacciones, mano de obra y reportes de estado.",
      icon: "ri-shield-star-line",
    },
    {
      title: "Diagnóstico y Auditoría",
      description:
        "Evaluación técnica completa del estado actual de tus instalaciones. Reporte detallado con fotografías, recomendaciones y presupuesto para mejoras necesarias.",
      icon: "ri-search-line",
    },
    {
      title: "Refacciones Originales",
      description:
        "Suministro de refacciones y repuestos originales para todas las marcas que distribuimos. Inventario local y tiempos de entrega reducidos para minimizar el downtime.",
      icon: "ri-settings-4-line",
    },
  ],
  contact:
    "En caso de requerir asesoría personalizada para elegir la solución adecuada a tu requerimiento, favor de contactarnos al teléfono: +52 477 284 70 60 / correo: comercial@ventracore.com.mx",
};

export const serviciosGeneralesData = {
  intro:
    "Además de nuestros servicios especializados, ofrecemos una gama de servicios generales que complementan las necesidades de nuestros clientes. Desde auditorías hasta asesoría técnica, estamos preparados para brindar soluciones integrales.",
  features: [
    {
      title: "Auditorías Técnicas",
      description:
        "Evaluación exhaustiva de instalaciones existentes para identificar oportunidades de mejora, cumplimiento normativo y optimización de recursos operativos.",
      icon: "ri-clipboard-line",
    },
    {
      title: "Asesoría Técnica",
      description:
        "Consultoría especializada para la toma de decisiones en proyectos de climatización, electricidad y energía. Apoyo en la selección de equipos, diseño y presupuestos.",
      icon: "ri-customer-service-2-line",
    },
    {
      title: "Proyectos Llave en Mano",
      description:
        "Ejecución completa de proyectos desde la ingeniería conceptual, diseño, suministro de equipos, instalación, puesta en marcha y capacitación del personal operativo.",
      icon: "ri-building-2-line",
    },
    {
      title: "Capacitación al Cliente",
      description:
        "Entrenamiento del personal del cliente en operación básica, mantenimiento menor, identificación de alarmas y protocolos de emergencia de los equipos instalados.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Gestión de Proyectos",
      description:
        "Coordinación integral de proyectos con cronogramas definidos, control de calidad, gestión de proveedores y entregas a tiempo para cumplir con los objetivos del cliente.",
      icon: "ri-projector-line",
    },
    {
      title: "Soporte Remoto",
      description:
        "Asistencia técnica a distancia para diagnóstico de fallas, configuración de equipos y monitoreo. Reducción de tiempos de respuesta y costos de desplazamiento.",
      icon: "ri-computer-line",
    },
  ],
  contact:
    "En caso de requerir asesoría personalizada para elegir la solución adecuada a tu requerimiento, favor de contactarnos al teléfono: +52 477 284 70 60 / correo: comercial@ventracore.com.mx",
};